var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6801 16.8631C31.6801 15.7285 31.5783 14.6376 31.3892 13.5903H16.3201V19.7794H24.931C24.5601 21.7794 23.4328 23.474 21.7383 24.6085V28.6231H26.9092C29.9346 25.8376 31.6801 21.7358 31.6801 16.8631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3197 32.4996C20.6397 32.4996 24.2615 31.0668 26.9088 28.6232L21.7378 24.6086C20.3051 25.5686 18.4724 26.1359 16.3197 26.1359C12.1524 26.1359 8.62512 23.3214 7.36694 19.5396H2.02148V23.685C4.65421 28.9141 10.0651 32.4996 16.3197 32.4996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36734 19.5414C7.04734 18.5814 6.86553 17.5559 6.86553 16.5014C6.86553 15.4468 7.04734 14.4214 7.36734 13.4614V9.31592H2.02189C0.901887 11.5455 0.319081 14.0063 0.32007 16.5014C0.32007 19.0832 0.938252 21.5268 2.02189 23.6868L7.36734 19.5414Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3197 6.86413C18.6688 6.86413 20.7778 7.6714 22.436 9.25686L27.0251 4.66776C24.2542 2.08594 20.6324 0.500488 16.3197 0.500488C10.0651 0.500488 4.65421 4.08594 2.02148 9.31504L7.36694 13.4605C8.62512 9.67867 12.1524 6.86413 16.3197 6.86413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.2c9b6d9d8da562937f865fb8a0776e4a.svg";
export { ForwardRef as ReactComponent };